import { useEffect, useRef, useState } from "react";
import { Accordion, Form } from 'react-bootstrap';
import axios from 'axios';
import environment from '../../../environment';
import useParams from "../../../services/helpers/custom_hook/paramsUrl";
import EspecialCardMenu from "../../../shared/components/especial_card_menu/especial_card_menu";
import './styles.css'

function PropertyFilter({ queryFilters, setgfilter, counties, countiesError, setQueryFilters, setPage }) {
  const [setParamsUrl, setFiltersFromUrl] = useParams();
  const [propertyTypes, setPropertyTypes] = useState([]);
  const formRef = useRef();

  const getPropertyTypes = async () => {
    try{
      const { data } = await axios.get(`${environment.ENDPOINT_CAPIRENTBACKEND}/types`);
      setPropertyTypes(data.data);
    } 
    catch(error) {
      setPropertyTypes([])
    }
  }

  const saveEvent = async () => {
    try{
      const { data } = await axios.post(`${environment.ENDPOINT_CAPIRENTBACKEND}/event/add`, {
        category: 'Listado de propiedades',
        action: 'Buscar',
        data: {...filter}
      });
    } 
    catch(error) {

    }
  }

  useEffect(() => {
    getPropertyTypes()
  }, [])

  const queryparams = {
    condition: undefined,
    type: undefined,
    conmune: undefined,
    bathrooms_quantity: undefined,
    bedrooms_quantity: undefined,
    rental_fee_gte: undefined,
    rental_fee_lte: undefined,
    total_area_gte: undefined,
    total_area_lte: undefined,
    parking: undefined,
    warehouse: undefined,
    furnished: undefined,
  };

  const [filter, setFilter] = useState(queryFilters == undefined ? queryparams : queryFilters);

  const handleInputChange = (event) => {
    setFilter({
      ...filter,
      [event.target.name]: event.target.value !== "" && event.target.value !== "undefined" ? event.target.value : undefined,
    });
  };

  const handleCheckChange = (event) => {
    console.log(event.target.checked)
    setFilter({
      ...filter,
      [event.target.name]: (event.target.checked !== "" && event.target.checked !== "undefined") ? event.target.checked ? 1 : 0 : undefined,
    });
  };

  const handleInputChangeRental = (event) => {
    setFilter({
      ...filter,
      rental_fee: { ...filter.rental_fee, [event.target.name]: event.target.value !== "" ? event.target.value : undefined },
    });
  };

  const setConditionFilter = (condition) => {
    const rental_fee_gte = ''
    const rental_fee_lte = ''
    setFilter({ ...filter, condition, rental_fee_gte,  rental_fee_lte})
  }

  const sendFilter = (event) => {
    event.preventDefault();
    setQueryFilters(filter);
    setgfilter(filter)
    setPage(1)
    setParamsUrl(filter)
    saveEvent();
  };

  const resetFilters = () => {
    document.querySelectorAll('input[type=checkbox]').forEach( el => el.checked = false );
    formRef.current.reset();
    setFilter(queryparams);  
  }

  const shouldDisplayReset = () => {
    return Object.values(filter).every((el) => el === undefined)
  }

  const isDefaultOpen = () => {
    if (filter.type || filter.total_area_gte || filter.total_area_lte || filter.parking || filter.warehouse || filter.furnished) {
      return '0';
    }
    return null;
  }

  return (
    <EspecialCardMenu title='Filtrar la búsqueda'>
      <form onSubmit={sendFilter} ref={formRef}>
        <div className='p-4'>
          <div className='form-group pb-3'>
            <span className='subhead-regular'>Filtra por comuna</span>
            <select className='custom-select w-100 microcopy-light' onChange={handleInputChange} name='conmune' value={filter.conmune}>
              <option disabled>
                Selecciona una comuna
              </option>
              <option value='undefined'>Todas las comunas</option>
              {counties.data?.map((county) => (
                <option value={county.id} key={county.id} className='microcopy-light'>{county.name}</option>
              ))}
            </select>
          </div>
          
          <div>
            <h6 className='subhead-regular'>Filtra por precio UF</h6>
            <div className='row'>
              <div className='col-6'>
                <input
                  type='number'
                  min='0'
                  pattern='[0-9]{10}'
                  placeholder='Precio Min'
                  className='custom-input w-100 microcopy-light'
                  onChange={handleInputChange}
                  name='rental_fee_gte'
                  value={filter.rental_fee_gte}
                ></input>
              </div>
              <div className='col-6'>
                <input
                  type='number'
                  min='0'
                  pattern='[0-9]{10}'
                  placeholder='Precio Max'
                  className='custom-input w-100 microcopy-light'
                  onChange={handleInputChange}
                  name='rental_fee_lte'
                  value={filter.rental_fee_lte}
                ></input>
              </div>
            </div>
          </div>

          <h6 className='subhead-regular mt-3'>Filtra por tipología</h6>
          <div className='row pb-3'>
            <div className='col-6'>
              <input
                type='number'
                min='0'
                pattern='[0-9]{10}'
                placeholder='Nro Baños'
                className='custom-input w-100 microcopy-light'
                onChange={handleInputChange}
                name='bathrooms_quantity'
                value={filter.bathrooms_quantity}
              ></input>
            </div>
            <div className='col-6'>
              <input
                type='number'
                min='0'
                pattern='[0-9]{10}'
                placeholder='Nro Dormitorios'
                className='custom-input w-100 microcopy-light'
                onChange={handleInputChange}
                name='bedrooms_quantity'
                value={filter.bedrooms_quantity}
              ></input>
            </div>
          </div>
          {countiesError && (
            <div
              className={
                'mt-3 alert fade show alert-warning'}
              role="alert"
            >
              <strong>{countiesError}</strong>
            </div>
          )}
        </div>
        <Accordion flush defaultActiveKey={isDefaultOpen}>
          <Accordion.Item eventKey="0" className="accordion-wrapper">
            <Accordion.Header><p className="m-0" style={{ 'font-size': '20px' }}>Más filtros</p></Accordion.Header>
            <Accordion.Body>
              <div className='form-group pb-3'>
                <span className='subhead-regular'>Tipo de Propiedad</span>
                <select className='custom-select w-100 microcopy-light' onChange={handleInputChange} name='type' value={filter.type}>
                  <option disabled>
                    Selecciona un tipo de propiedad
                  </option>
                  <option value='undefined'>Todos los tipos de propiedad</option>
                  {propertyTypes.map((type) => (
                    <option value={type.id} key={type.id} className='microcopy-light'>{type.name}</option>
                  ))}
                </select>
              </div>
              <h6 className='subhead-regular'>Superficie Total</h6>
              <div className='row'>
                <div className='col-6'>
                  <input
                    type='number'
                    min='0'
                    pattern='[0-9]{10}'
                    placeholder='Desde (M2)'
                    className='custom-input w-100 microcopy-light'
                    onChange={handleInputChange}
                    name='total_area_gte'
                    value={filter.total_area_gte}
                  />
                </div>
                <div className='col-6'>
                  <input
                    type='number'
                    min='0'
                    pattern='[0-9]{10}'
                    placeholder='Hasta (M2)'
                    className='custom-input w-100 microcopy-light'
                    onChange={handleInputChange}
                    name='total_area_lte'
                    value={filter.total_area_lte}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12 col-md-6 mt-2">
                  <Form.Check
                    reverse
                    type="switch"
                    id="parking"
                    name="parking"
                    label="Estacionamiento"
                    value={filter.parking}
                    checked={filter.parking}
                    onChange={handleCheckChange}
                  />
                </div>
                <div className="col-12 col-md-6 mt-2">
                  <Form.Check 
                    type="switch"
                    id="warehouse"
                    name="warehouse"
                    label="Bodega"
                    value={filter.warehouse}
                    checked={filter.warehouse}
                    onChange={handleCheckChange}
                  />
                </div>
                <div className="col-12 col-md-6 mt-2">
                  <Form.Check 
                    type="switch"
                    id="furnished"
                    name="furnished"
                    label="Amoblado"
                    value={filter.furnished}
                    checked={filter.furnished}
                    onChange={handleCheckChange}
                  />
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="form-button-wrappers">
          <button className='btn text-white form-button mt-2 h-62' type='submit'>
            Mostrar resultados
          </button>
          <button className={`border-0 w-100 mt-2 clean-all-filters h-62 ${!shouldDisplayReset() ? '' : 'd-none'}`} onClick={resetFilters}>
            Limpiar filtros
          </button>
        </div>
      </form>
    </EspecialCardMenu>
  );
}

export default PropertyFilter;
